<div class="tarjeta rounded-2 d-flex mt-2 p-3" [ngClass]="[customClass, loading ? 'loading' : '']">
  <img src="assets/icons/archivo-cargado.svg" style="height: 42px; margin: auto 0;" class="me-3" [hidden]="!loading && document.nombre===''"/>
  <div class="w-100 d-flex align-items-center" *ngIf="!loading && document.nombre!=''; else documentName">
      <div class="name pe-1 text-wrap flex-fill" style="max-width: 13rem;">{{document.nombre}}</div>
      <span class="size ps-1 fw-normal">{{document.archivo.size | fileSize}}</span>
      <app-hyperlink-icon icon="delete" (clicked)="eliminar()">Eliminar</app-hyperlink-icon> 
  </div>
  <ng-template #documentName>
      <div class="d-md-flex w-100 align-items-center" *ngIf="!loading">
        <div class="form-field flex-grow-1">
          <label for="documentName" class="form-label">Nombre de archivo</label>
          <input type="text" class="form-control" placeholder="*Nombre de archivo" id="documentName" autocomplete="off" [(ngModel)]="fileNameInput">
          <div class="form-error" *ngIf="fileNameInput.trim() === ''">
            Debes asignar un nombre al archivo
          </div>
        </div>
        <button-look-feel color="secondary" size="small" customClass="mt-md-2" (clicked)="guardarNombre()" [disabled]="fileNameInput===''">Guardar</button-look-feel>
      </div>
    </ng-template>
  <ng-container *ngIf="loading">
    <div class="w-100">
      <div class="fw-semibold">
        Cargando
      </div>
      <app-progress></app-progress>
    </div>
  </ng-container>
</div>
